<template>
  <div class="index-order-detail-host">
  <el-dialog title="股指订单详情" :visible="!!orderId" width="720px" custom-class="pc-trade-dialog" append-to-body @close="$emit('close')">
    <div v-loading="loading" element-loading-background="var(--theme-panel)">
      <p v-if="error" role="alert">{{ error }} <button @click="load">重试</button></p>
      <dl v-if="info" class="index-order-details"><div v-for="field in fields" :key="field[0]"><dt>{{ field[0] }}</dt><dd :class="fieldClass(field[0])">{{ field[1] }}</dd></div></dl>
    </div>
  </el-dialog>
  </div>
</template>
<script>
import { indexRequest, indexRealizedProfit, indexQuoteClass } from './indexTrade'
import { quoteDisplay, quotePrice } from '@/utils/quoteDisplay'
export default {
  props: { orderId: [Number, String] },
  data: () => ({ info: null, loading: false, error: '', sequence: 0 }),
  computed: {
    profit() { return this.info ? indexRealizedProfit(this.info) : null },
    fields() {
      const value = this.info || {}, currency = value.currency_code ? ' ' + value.currency_code : ''
      const money = key => quoteDisplay(value[key], currency, 1, 2)
      return [
        ['股指名称', value.index_name || '--'], ['股指代码', (value.indexInfo || {}).show_code_name || value.index_code || '--'],
        ['订单编号', value.id || '--'], ['方向', Number(value.order_type) === 2 ? '做空' : '做多'],
        ['交易操作', Number(value.entrust_order_type) === 2 ? '平仓' : '开仓'],
        ['买卖', ({1:'买入',2:'卖出'})[value.entrust_order_type] || '--'],
        ['委托类型', Number(value.entrust_type) === 0 ? '限价' : '市价'],
        ['委托价格', quotePrice(value.entrust_price, currency)], ['委托手数', quoteDisplay(value.entrust_hand, '', 1, 1)],
        ['成交价格', quotePrice(value.trade_price, currency)], ['成交手数', quoteDisplay(value.deal_hand, '', 1, 1)],
        ['杠杆倍数', quoteDisplay(value.lever)], ['交易汇率', quoteDisplay(value.trade_rate)],
        ['交易总价', money('total_price')], ['开仓成本价', quotePrice(value.sell_avg_price, currency)],
        ['已实现盈亏', this.profit == null ? (Number(value.entrust_order_type) === 1 ? '开仓成交（不计已实现盈亏）' : '--') : quoteDisplay(this.profit, currency, 1, 2)],
        ['交易佣金', money('commission')], ['佣金点数', quoteDisplay(value.commission_point)],
        ['折合人民币', quoteDisplay(value.exchange_rate_price, ' CNY', 1, 2)],
        ['平仓返还金额', money('sell_back_account_price')], ['交易时间', value.create_time || '--'],
        ['平仓原因', Number(value.is_close) === 1 ? ({0:'强平',1:'赎回',2:'触发熔断'})[value.close_type] || '--' : '--']
      ]
    }
  },
  watch: { orderId: { immediate: true, handler: 'load' } },
  beforeDestroy() { this.sequence++ },
  methods: {
    tone: indexQuoteClass,
    fieldClass(label) {
      const value = this.info || {}
      if (label === '已实现盈亏') return this.profit == null ? '' : 'profit-value ' + this.tone(this.profit)
      if (label === '买卖') return Number(value.entrust_order_type) === 1 ? 'order-buy' : Number(value.entrust_order_type) === 2 ? 'order-sell' : ''
      if (label === '方向') return Number(value.order_type) === 1 ? 'order-buy' : Number(value.order_type) === 2 ? 'order-sell' : ''
      if (label === '交易操作') return 'order-action'
      return ''
    },
    async load() {
      const sequence = ++this.sequence, id = this.orderId
      this.info = null; this.error = ''; this.loading = false
      if (!id) return
      this.loading = true
      try {
        const info = await indexRequest('entrustOrderDetail', { entrust_order_id: id })
        if (sequence !== this.sequence) return
        if (!info || String(info.id) !== String(id)) throw Error('订单详情暂不可用')
        this.info = info
      } catch (_) { if (sequence === this.sequence) this.error = '订单详情加载失败，请重试' }
      finally { if (sequence === this.sequence) this.loading = false }
    }
  }
}
</script>
<style scoped>
.index-order-details { margin:0; font-size:14px; }
.index-order-details > div { display:flex; justify-content:space-between; gap:16px; padding:6px 0; border-bottom:1px solid var(--theme-border); }
dt { color:var(--theme-muted); } dd { margin:0; text-align:right; overflow-wrap:anywhere; }
.rise { color:var(--quote-up); } .fall { color:var(--quote-down); }
.profit-value { font-weight:700; font-size:16px; }
.order-buy,.order-sell { padding:2px 8px; border-radius:4px; font-weight:600; }
.order-buy { color:#ff4a4a; background:#ff4a4a18; }
.order-sell { color:#1890ff; background:#1890ff18; }
.order-action { color:var(--theme-accent); font-weight:600; }
button { color:var(--theme-label); background:var(--theme-input); border:1px solid var(--theme-border); cursor:pointer; }
</style>
